export enum SessionStorageConstantsEnum {
  APP_PROPS = '@pra-vendas-app-props',
}
